export enum CookieConsent {
    STRICTLY_NECESSARY = 1,
    PERFORMANCE_COOKIES = 2,
    FUNTIONAL_COOKIES = 3,
    TARGETING_COOKIES = 4,
    MEDIA_COOKIES = 8,
}
